import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { environment } from '../../../environments/environment';
import { ILevelType, INewLevelData, LevelService } from '../../_service';

@Component({
    moduleId: module.id,
    templateUrl: 'list.component.html'
})
export class ListComponent implements  OnInit, OnDestroy {
    levelList: string[];
    isCreatingNew: boolean = false;
    levelTypes: ILevelType[];
    levelData: INewLevelData = null;
    playUrl: string;
    validationErrors: string[] = [];

    constructor(
        private _levelService: LevelService,
        private _toasterService: ToasterService,
        private _router: Router) {

            this._levelService.getLevelList().subscribe(list => {
                this.levelList = list;
            },
            error => {
                console.error(error);
            });

    }

    ngOnInit() {
        this.levelTypes = this._levelService.levelTypes;
        this.isCreatingNew = false;
        this.playUrl = environment.basePozzwareUrl + "WebGame/index.html?"
    }
   
    ngOnDestroy(): void {
        Object.keys(this).map(k => {
            this[k] = null;
        });
    }



    getLevelType(level: string): string {
        return this._levelService.getLevelType(parseInt(level.split('@')[1])).name;
    }
    
    getLevelName(level: string): string {
        return level.split('@')[0];
    }

    editLevel(levelName: string): void {
        this._router.navigateByUrl('editor/edit?name=' + levelName);
    }

    createNewClick() {
        this.isCreatingNew = true;
        this.levelData = {
            columns: 50,
            rows: 20,
            name: "",
            levelType: 0
        };
    }

    confirmClick() {
        if (this.checkData(this.levelData)) {
            var levelName: string = `${this.levelData.name}@${this.levelData.levelType}`;
            this._levelService.saveLevel(levelName, this.getLevelMap(this.levelData.columns, this.levelData.rows)).subscribe(data => {
                this._router.navigateByUrl('editor/edit?name=' + levelName);
            },
                error => {
                    this._toasterService.pop("error", error);
                    console.error(error);
                });
        }
    }

    private getLevelMap(columns: number, rows: number): string {
        var result: string = "";
        for(var r: number = 0; r < rows; r++) {
            for(var c: number = 0; c < columns; c++) {
                if (r==15 && c==10) result += "~"
                else if (r==16 && c==10) result += "A"
                else result+= " ";
            }
            result += '\n';
        }
        return result;
    }

    private checkData(data: INewLevelData): boolean {
        this.validationErrors = [];
        var pattern: RegExp=/^[A-Za-z0-9_]*$/;
        if (data.name.length <= 0 || !pattern.test(data.name)) {
            this.validationErrors.push("invalidName");
        }
        if (data.columns < 50 || data.columns > 700) {
            this.validationErrors.push("invalidColumns");
        }
        if (data.rows < 20 || data.rows > 500) {
            this.validationErrors.push("invalidRows");
        }

        var found = false;
        this.levelTypes.forEach((value)=>{
            if (value.id == data.levelType) found = true;
        });
        if (!found) {
            this.validationErrors.push("invalidLevelType");
        }

        return this.validationErrors.length == 0;
    }
    

}


// WEBPACK FOOTER //
// ./src/app/pages/list/list.component.ts